// extracted by mini-css-extract-plugin
export default {"Landing":"Landing_Landing__E+K6S","default__div":"Landing_default__div__0R-FS","dev__details":"Landing_dev__details__NfB8X"};